import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, Checkbox } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ParamsLibroAdministracion;
export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReporteLibroAdministracion extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            FechaDesde: validation.required,
            FechaHasta: validation.required,
            IdSucursal: validation.required
        };
    }

    onGenerarLibroAdministracion = async () => {
        const guiasDoc = await resources.RepLibroAdministracion.Generar(this.state.value);
        await kea.download(guiasDoc, "Libro administración de sucursales.xls");
    }

    render() {
        const getField = this.getField;
        const DateTime = getField(kea.DateTime);
        const Sucursal = getField(selectores.Sucursal);
        return (
            <div>
                <kea.Title titulo="Libro de administración de sucursales" onRegresar={() => history.go("../")} />
                {kea.autogrid(4, [
                    <DateTime field="FechaDesde" label="Fecha desde" />,
                    <DateTime field="FechaHasta" label="Fecha hasta" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />
                ])}
                <div className="row">
                    <div className="col-md-12">
                        <div className="btn-group">
                            <kea.Button children="Generar" style="success" onClick={this.onGenerarLibroAdministracion} disabled={validation.hasError(this.errors())} />
                        </div>
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reportelibroadministracion/index.tsx